<template>
  <div
    v-if="dittoPlus"
    class="loader plus"
  >
    <span class="plus-icon" />
    <span class="plus-icon" />
  </div>
  <div
    v-else
    class="loader"
  >
    <Icon
      name="loading"
      title="Loading"
      :fill="iconFill"
    />
  </div>
</template>

<script>
import Icon from './Icon.vue'

export default {
  name: 'SvgLoader',
  components: {
    Icon,
  },
  props: {
    dittoPlus: { type: Boolean, default: false },
    iconFill: { type: String, default: 'blue-alternate' },
  },
}
</script>

<style lang="scss">
.loader {
  margin: 0 auto;
}
</style>
